import PropTypes from 'prop-types'
import React from 'react'
import Icon from '../images/teepee-favicon-source-white.png'

const Header = props => (
  <header id="header" style={props.timeout ? { display: 'none' } : {}}>
    <div className="logo">
      <span style={{
        backgroundImage: `url(${Icon})`,
        height: '10rem',
        width: '10rem',
        display: 'inline-block',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }}/>
    </div>
    <div className="content">
      <div className="inner">
        <h1>Teepeetoyou</h1>
        <p>
          Luxury Teepee ⛺️ and Bell tent 🎪 available for hire.
        </p>
      </div>
    </div>
    <nav>
      <ul>
        {/*<li>*/}
        {/*  <button*/}
        {/*    onClick={() => {*/}
        {/*      props.onOpenArticle('intro')*/}
        {/*    }}*/}
        {/*  >*/}
        {/*    Intro*/}
        {/*  </button>*/}
        {/*</li>*/}
        {/*<li>*/}
        {/*  <button*/}
        {/*    onClick={() => {*/}
        {/*      props.onOpenArticle('work')*/}
        {/*    }}*/}
        {/*  >*/}
        {/*    Work*/}
        {/*  </button>*/}
        {/*</li>*/}
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('about')
            }}
          >
            About
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('contact')
            }}
          >
            Contact
          </button>
        </li>
      </ul>
    </nav>
  </header>
)

Header.propTypes = {
  onOpenArticle: PropTypes.func,
  timeout: PropTypes.bool,
}

export default Header
